import React from 'react';
import { useLang } from '../context/LanguageContext';

export default function HelpPage({ onBack }) {
  const { t } = useLang();
  const h = t.help;

  return (
    <div className="max-w-4xl mx-auto px-6 py-10">
      <button onClick={onBack} className="flex items-center gap-1 text-sm text-slate-400 hover:text-slate-700 mb-8 transition-colors">
        {h.back}
      </button>

      <div className="mb-10">
        <h1 className="text-3xl font-black text-slate-900 mb-2">{h.title}</h1>
        <p className="text-slate-500">{h.subtitle}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {h.sections.map((s) => (
          <div key={s.title} className="card p-6">
            <div className="w-12 h-12 bg-primary-50 rounded-2xl flex items-center justify-center text-2xl mb-4">{s.icon}</div>
            <h3 className="font-bold text-slate-900 mb-2">{s.title}</h3>
            <p className="text-sm text-slate-500 leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-10 bg-slate-50 rounded-2xl p-8 text-center border border-slate-100">
        <p className="text-slate-400 text-sm">{h.soon}</p>
      </div>
    </div>
  );
}
